import { GetDistributorDetailsResponse } from '@Common/types/bo_external/distributor/details';

export const distributorTranslations = {
  title: 'Tableau de bord Apporteur',
  sub_titles: {
    dashboard: 'Tableau de bord',
    details: 'Détails',
    address: 'Adresse',
  },
  fields: {
    id: 'ID Distributeur',
    firstname: 'Prénom',
    lastname: 'Nom',
    orias_code: 'Code ORIAS',
    email: 'Email',
    landline: 'Téléphone fixe',
    phone_number: 'Téléphone portable',
    collective_inspector_email: 'Email de l’inspecteur collectif',
    created_at: 'Créé le',
    street: 'Rue',
    postal_code: 'Code postal',
    city: 'Ville',
    country_code: 'Pays de résidence',
    company_name: "Nom de l'entreprise",
  } satisfies Record<keyof GetDistributorDetailsResponse, string>,
  dashboard: {
    outstanding_timeline: {
      title: 'Histogramme des collectes',
      range: {
        today: "Aujourd'hui",
        last_n_days: 'Les %{days} derniers jours',
        last_week: 'La semaine dernière',
        last_month: 'Le mois dernier',
        last_year: "L'année dernière",
      },
    },
    outstanding_breakdown: {
      title: "Montants d'encours ventilés",
      contracts: 'Par contrat',
      plans: 'Par produit',
      instruments: 'Par fonds',
    },
    companies_employees_distribution: {
      companies: {
        title: 'Entreprises',
        active: 'Actives',
        inactive: 'Inactives',
        total: "Nombre d'entreprises",
      },
      employees: {
        title: 'Adhérents',
        active: 'Actifs',
        inactive: 'Inactifs',
        total: "Nombre d'adhérents",
      },
    },
    tabs: {
      standard: 'Standard',
      er: 'ER',
    },
  },
};
